import axios from 'axios';

export default {
  list: (params = {}, config = {}) => axios.get('financial-accounts/transfers', { params, ...config }),
  store: (payload = {}, config = {}) => axios.post('financial-accounts/transfers', payload, config),
  update: (transferId, payload = {}, config = {}) => axios.put(`financial-accounts/transfers/${transferId}`, payload, config),
  delete: (transferId, config = {}) => axios.delete(`financial-accounts/transfers/${transferId}`, config),
};
